import { Navigate, useLocation } from 'react-router-dom';

/**
 * Legacy URL redirect for /parent-registration -> /parent/register
 * Preserves query parameters (especially ?code=XXX)
 *
 * Can be removed after 6/1/2026
 */
export default function ParentRegistrationRedirect() {
  const location = useLocation();
  return <Navigate to={`/parent/register${location.search}`} replace />;
}
